import Modal from "react-bootstrap/Modal";
import Dropdown from "react-bootstrap/Dropdown";
import { useAppSelector } from "../../store/hooks";
import { selectUser } from "../../store/features/user";
import { getToken } from "../../backend/StorageUtils";
import { Translate, withLocalize } from "react-localize-redux";
import { Link } from "react-router-dom/cjs/react-router-dom";
import BaseButton from "wallet-elementkit/dist/elementKit/baseButton/BaseButton";
import { Subdomains } from "wallet-elementkit/dist/constants";
import { langs } from "../../translations/translateJsonFile";
import SheetFooter from "../sheetFooter/SheetFooter";
import translations from "../../translations/welcomeSheet.json";
import "../../styles/components/welcomeSheet/welcomeSheetWeb.scss";
import styled from "styled-components";
import { getMasterConfig } from "wallet-elementkit/dist/constants/master";

const StyledWelcomeSheetWeb = styled.div`
	${(props) => `
    .customizable-text {
      color: ${props.textColor} !important;
    }
	.customizable-icon {
		fill: ${props.primaryColor} !important;
	}
	.active {
		.customizable-icon {
			fill: #fff !important;
		}
	}
  `};
`;
const WelcomeSheetWeb = (props) => {
	props.addTranslation(translations);
	const userMeta = useAppSelector(selectUser);
	const config = getMasterConfig();
	function checkLoggedIn() {
		return getToken() && userMeta && userMeta.logged;
	}

	function redirectToEmailVerify() {
		return checkLoggedIn() && !userMeta.isMailConfirmed;
	}

	return (
		<StyledWelcomeSheetWeb>
			<Modal
				size="sm"
				show={props.sheetOpen}
				onHide={props.onClose}
				animation={false}
				dialogClassName="welcome-sheet-web"
				backdropClassName="header-modal-backdrop"
			>
				<Modal.Header>
					<Modal.Title
						className="welcome-text"
						style={{
							marginTop: "15px",
							marginBottom: "29px",
						}}
					>
						<Translate
							id="welcomeDetailedText"
							data={{
								organizationName: config.organizationName,
							}}
						/>
					</Modal.Title>
				</Modal.Header>

				<Modal.Body className="flex-column ai-c">
					<div>
						<Link
							to={{
								pathname: `/${
									props.activeLanguage ? props.activeLanguage.code : "en"
								}/${redirectToEmailVerify() ? "verify-email" : "signup"}/`,
							}}
						>
							<BaseButton
								type="primary"
								size="small"
								width={200}
								loading={false}
								backgroundColor={props.config.primaryColor}
								onClickAction={props.onClose}
							>
								<Translate id="signup" />
							</BaseButton>
						</Link>
						<Link
							to={`/${
								props.activeLanguage ? props.activeLanguage.code : "en"
							}/${redirectToEmailVerify() ? "verify-email" : "login"}/`}
						>
							<BaseButton
								type="primary"
								size="small"
								width={200}
								loading={false}
								backgroundColor={props.config.primaryColor}
								styles={{ margin: "16px 0" }}
								onClickAction={props.onClose}
							>
								<Translate id="login" />
							</BaseButton>
						</Link>
					</div>
					{config.subDomain !== Subdomains.bitdefender && (
						<Dropdown
							id="dropdown-basic-button"
							style={{
								width: "100%",
							}}
							onSelect={(langCode) => {
								props.changeLang(langCode);
							}}
						>
							<Dropdown.Toggle>
								<BaseButton
									type="secondary"
									size="small"
									loading={false}
									backgroundColor={props.config.primaryColor}
									width={200}
								>
									<span>
										{props.activeLanguage ? props.activeLanguage.name : ""}
									</span>
								</BaseButton>
							</Dropdown.Toggle>
							<Dropdown.Menu>
								{langs.certificateLanguages.map((language) => (
									<Dropdown.Item eventKey={language.code} key={language.code}>
										{language.name}
									</Dropdown.Item>
								))}
							</Dropdown.Menu>
						</Dropdown>
					)}
				</Modal.Body>
				{config.subDomain !== Subdomains.bitdefender && (
					<Modal.Footer>
						<SheetFooter />
					</Modal.Footer>
				)}
			</Modal>
		</StyledWelcomeSheetWeb>
	);
};

export default withLocalize(WelcomeSheetWeb);
